module.exports = __webpack_public_path__ + "img/hat_2.a5e4fe40.png";